import { PLAN_OS_SUCCESS, PLAN_OS_LOADING, PLAN_OS_ERROR, PLAN_OS_RESET } from "../../ActionTypes";

import axiosInstance from "../../../../global/helpers/axiosInstance";
import axiosLogin from "../../../../global/helpers/axiosLogin";

export const planObraSocial = (codigoObraSocial) => (dispatch) => {
  dispatch({
    type: PLAN_OS_LOADING,
  });
 axiosLogin().then(respuesta => {
  respuesta
  .get(`/shared/obras-sociales/${codigoObraSocial}/planes` )
  .then((res) => {
    dispatch({
      type: PLAN_OS_SUCCESS,
      payload: res.data,
    });
  })
  .catch((err) => {
    let error = {
      detail: err.response
        ? err.response.data
        : "Error al contactar el server.",
    };

    dispatch({
      type: PLAN_OS_ERROR,
      payload: error,
    });
  });
 } )
};
// export const planObraSocial = (codigoObraSocial) => (dispatch) => {
//   dispatch({
//     type: PLAN_OS_LOADING,
//   });
//  axiosInstance().then(respuesta => {
//   respuesta
//   .get(`/registro/planes_os/${codigoObraSocial}` )
//   .then((res) => {
//     dispatch({
//       type: PLAN_OS_SUCCESS,
//       payload: res.data,
//     });
//   })
//   .catch((err) => {
//     let error = {
//       detail: err.response
//         ? err.response.data
//         : "Error al contactar el server.",
//     };

//     dispatch({
//       type: PLAN_OS_ERROR,
//       payload: error,
//     });
//   });
//  } )
// };

export const removePlanObraSocial = () => (dispatch) => {
  dispatch({ type: PLAN_OS_RESET });
};